module.exports = __webpack_public_path__ + "static/media/small_arrow.f069b8e8.svg";